/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
    vue: {
        width: 400,
        height: 400,
        viewBox: '0 0 400 400',
        data:
            '<path pid="0" d="M237.417 86.655l-30.226 52.352-30.225-52.352H76.311l130.88 226.69 130.88-226.69z" _fill="#4dba87"/><path pid="1" d="M237.417 86.655l-30.226 52.352-30.225-52.352h-48.303l78.528 136.014L285.72 86.655z" _fill="#435466"/>'
    }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/icons/vue.ts